import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../Styles/ServiceDetails.css";

const SERVICES_URL =
  "https://raw.githubusercontent.com/DhotradSunnyDentalandOrthodonticClinics/website-services/main/Services.json";

const ServiceDetails = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(SERVICES_URL)
      .then((res) => res.json())
      .then((data) => {
        const foundService = data.find((item) => item.id === Number(id));
        setService(foundService);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load service details", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <h2 style={{ textAlign: "center" }}>Loading...</h2>;
  }

  if (!service) {
    return <h2 style={{ textAlign: "center" }}>Service not found</h2>;
  }

  return (
    <section className="service-details">
      <h1 className="service-title">{service.title}</h1>

      {/* Image */}
      <div className="service-details-image">
        <img src={service.image} alt={service.title} loading="lazy" />
      </div>

      {/* ✅ Render formatted HTML */}
      <div
        className="service-details-content"
        dangerouslySetInnerHTML={{ __html: service.fullContent }}
      />
    </section>
  );
};

export default ServiceDetails;
